const themesData = {
    violet: {
        name: "Violet",
        colors: {
            "--primary-background-color": "#120015",
            "--secondary-background-color": "#1E0038",
            "--tertiary-background-color": "#180021",
            "--secondary-background-color-opacity": "#1E0038CC",
            "--border-color": "#3C0F5B",
            "--primary-action-color": "#8000FF",
            "--secondary-action-color": "#D5006D",
            "--primary-shape-color": "#ffafd2",
            "--secondary-shape-color": "#e76cff",
            "--color": "#D3A8E6",
        },
    },
    rose: {
        name: "Rose",
        colors: {
            "--primary-background-color": "#330015",
            "--secondary-background-color": "#4A0020",
            "--tertiary-background-color": "#3D0018",
            "--secondary-background-color-opacity": "#4A0020CC",
            "--border-color": "#751840",
            "--primary-action-color": "#FF0099",
            "--secondary-action-color": "#E066FF",
            "--primary-shape-color": "#800080",
            "--secondary-shape-color": "#FF99CC",
            "--color": "#E5A8C4",
        },
    },
    rouge: {
        name: "Rouge",
        colors: {
            "--primary-background-color": "#2A0000",
            "--secondary-background-color": "#3F0613",
            "--tertiary-background-color": "#35030A",
            "--secondary-background-color-opacity": "#3F0613CC",
            "--border-color": "#8B1A1A",
            "--primary-action-color": "#FF4500",
            "--secondary-action-color": "#FF6F00",
            "--primary-shape-color": "#FF9B3D",
            "--secondary-shape-color": "#FF4F4F",
            "--color": "#FFC2C2",
        },
    },
    bleu: {
        name: "Bleu",
        colors: {
            "--primary-background-color": "#010C15",
            "--secondary-background-color": "#011e35",
            "--tertiary-background-color": "#011426",
            "--secondary-background-color-opacity": "#011e35CC",
            "--border-color": "#124766",
            "--primary-action-color": "#00BFFF",
            "--secondary-action-color": "#00ff00",
            "--primary-shape-color": "#43d9ad",
            "--secondary-shape-color": "#4d5bce",
            "--color": "#90A8C0",
        },
    },
    vert: {
        name: "Vert",
        colors: {
            "--primary-background-color": "#001A00",
            "--secondary-background-color": "#002600",
            "--tertiary-background-color": "#001F00",
            "--secondary-background-color-opacity": "#002600CC",
            "--border-color": "#145A14",
            "--primary-action-color": "#00CC66",
            "--secondary-action-color": "#66CCFF",
            "--primary-shape-color": "#4DA6FF",
            "--secondary-shape-color": "#66FF99",
            "--color": "#A8E6B8",
        },
    },
    orange: {
        name: "Orange",
        colors: {
            "--primary-background-color": "#331900",
            "--secondary-background-color": "#4A2600",
            "--tertiary-background-color": "#3D2000",
            "--secondary-background-color-opacity": "#4A2600CC",
            "--border-color": "#8B4A1A",
            "--primary-action-color": "#FF8000",
            "--secondary-action-color": "#FF0000",
            "--primary-shape-color": "#CC5544",
            "--secondary-shape-color": "#FFB347",
            "--color": "#FFD9B3",
        },
    },
};

export default themesData;
